import { render, staticRenderFns } from "./PortfolioAccessControl.vue?vue&type=template&id=4f06fcfa&"
import script from "./PortfolioAccessControl.vue?vue&type=script&lang=js&"
export * from "./PortfolioAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports